<sm-title-bar [pageTitle]="pageTitle" [back]="true" > </sm-title-bar>
<!-- <mat-card appearance="outlined" >
    <mat-card-header class="justify-content-between align-items-center mb-3">
      
       </mat-card-header>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="customerBookingData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [itemsPerPage]="25">
      </sm-data-table>
    </div>
  </mat-card> -->
  
  <div class="customer_payment" *ngIf="!loader && customerBookingData.length > 0">
<mat-card *ngFor="let item of customerBookingData" (click)="viewDetails(item)">
    <div class="package-card" >
      <div class="package-header">
        <div class="profile-container">
          <div class="profile-image1" *ngIf="item.current_status == 0 || item.current_status == 1 || item.current_status == 2">
            <mat-icon class="status-icon" >star</mat-icon> 
          </div>
          <div class="profile-image2" *ngIf="item.current_status == 3 || item.current_status == 9">
            <mat-icon class="status-icon" >schedule</mat-icon>

          </div>
          <div class="profile-image3" *ngIf="item.current_status == 5">
            <mat-icon class="status-icon" >check_circle</mat-icon>

          </div>
          <div class="profile-image4" *ngIf="item.current_status == 7">
            <mat-icon class="status-icon" >group_add</mat-icon>

          </div>  
          <div class="profile-image5" *ngIf="item.current_status == 6 || item.current_status == 8 ">
            <mat-icon class="status-icon" >cancel</mat-icon>

          </div>  
          <div class="profile-image6" *ngIf="item.current_status == 4">
            <mat-icon class="status-icon" >task_alt</mat-icon>

          </div>  
          <div class="all_booking_cut">
          <h2 class="package-title">{{item.booking_date | date}}</h2>
          <p class="package-detail">{{item.scount}} service(s), <span class="package-highlight">{{item.currency_symbol}}{{item.price.toFixed(2)}}</span></p>
        </div>
        </div>
        <div class="package-options">
          <!-- <button mat-icon-button [matMenuTriggerFor]="menu" class="package-options" >
            <mat-icon>more_vert</mat-icon>
          </button> -->
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="viewDetails(item)">
              <mat-icon class="material-icons-outlined">info</mat-icon>
              <span>{{ 'customer_all_bookings.op1' | translate }}</span>
            </button>
            <button mat-menu-item (click)="openInvoice(item)" *ngIf="item.current_status == 4">
              <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
              <span>{{ 'customer_all_bookings.op2' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      
      
      <p class="package-status">Status: <span class="status-complete">{{item.bookingStat}}</span> 
      </p>
      <p class="package-status">  Payment due: {{item.currency_symbol}}{{item.payment_due.toFixed(2)}}</p>
     </div>

        <div class="arrow_iocn_x">
    <mat-icon>arrow_forward</mat-icon>
  </div>
  </mat-card>
  </div>
    
  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>{{ 'customer_all_bookings.op1' | translate }}</span>
    </button>
    <button mat-menu-item (click)="openInvoice(rowvalue)" *ngIf="rowvalue.current_status == 4">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'customer_all_bookings.op2' | translate }}</span>
    </button>
  </ng-template>


  <div class="row" *ngIf="!loader && customerBookingData.length == 0">
    <div class="col-sm-12" >
      <div style="padding: 20px 18px 20px 18px;border-radius: var(--dra-radius-x-small);transition: 0.3s;">
        <div class="top_section_order">
          <div class="row">
           <div class="nal_rrty">
            <div style="text-align:center;min-height: 500px;padding-top: 210px">
            <div class="cv_notifia">
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M16 25.069H5.21a2.312 2.312 0 0 1-2.31-2.31V8.02a2.312 2.312 0 0 1 2.31-2.31h2.172v.544a.9.9 0 0 0 1.8 0V5.71h10.764v.544a.9.9 0 0 0 1.8 0V5.71h2.164a2.313 2.313 0 0 1 2.31 2.31v6.43a.9.9 0 0 0 1.8 0V8.02a4.115 4.115 0 0 0-4.11-4.11h-2.164v-.46a.9.9 0 0 0-1.8 0v.46H9.182v-.46a.9.9 0 0 0-1.8 0v.46H5.21A4.115 4.115 0 0 0 1.1 8.02v14.74a4.114 4.114 0 0 0 4.11 4.11H16a.9.9 0 0 0 0-1.801z" fill="#808080" opacity="1" data-original="#000000" class=""></path><path d="M8.094 12.244a1.039 1.039 0 1 0 0 2.078 1.039 1.039 0 0 0 0-2.078zM14.563 12.244a1.039 1.039 0 1 0 0 2.078 1.039 1.039 0 0 0 0-2.078zM19.992 13.283a1.039 1.039 0 1 0 2.078 0 1.039 1.039 0 0 0-2.078 0zM8.094 17.905a1.039 1.039 0 1 0 0 2.078 1.039 1.039 0 0 0 0-2.078zM14.563 17.905a1.039 1.039 0 1 0 0 2.078 1.039 1.039 0 0 0 0-2.078zM24.507 16.665a6.401 6.401 0 0 0-6.394 6.393c0 3.524 2.868 6.393 6.394 6.393s6.394-2.868 6.394-6.393a6.401 6.401 0 0 0-6.394-6.393zm0 10.984c-2.532 0-4.593-2.06-4.593-4.592s2.061-4.593 4.593-4.593 4.593 2.061 4.593 4.593-2.061 4.592-4.593 4.592z" fill="#808080" opacity="1" data-original="#000000" class=""></path><path d="m25.811 21.421-1.972 1.589-.491-.627a.9.9 0 1 0-1.416 1.112l1.054 1.344a.898.898 0 0 0 1.272.146l2.682-2.16a.9.9 0 0 0-1.129-1.404z" fill="#808080" opacity="1" data-original="#000000" class=""></path></g></svg>
            </div>
            <div>
              <p style="margin-top: 18px; color: #a8a8a8; font-size: 17px;  line-height: 24px;">
                There's no booking record to show here. Re-visit the page or contact support team if there's any issue.
             </p>
           </div>
            </div>
          </div>
         </div>
        </div>
      </div>
    </div>
  </div>








  <!-- <mat-paginator
  *ngIf="!loader"
    class="mt-4"
    [length]="datalength"
    [pageSize]="25"
    (page)="onPageChange($event)"
  >
  </mat-paginator> -->